// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-prestige -> dietz-property-group-prestige -> cedar-creek-crossing-apartments
// Generated: 2026-09-23T21:41:07.972Z
// Counts: 1 design, 14 content, 2 slot group, 2 collection binding, 7 section, 1 style

export const designOverrides = {
  "design.block:multihub-lead-form.color.primary": {
    "cssVariable": "--vibe-color-primary",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_secondary_color"
  }
};

export const contentOverrides = {
  "header.interactive_map_show_if_exists": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_engrain_sightmap_url"
  },
  "interactivemapsection.map_block": {
    "overrideType": "VALUE",
    "customValue": "engrain-sitemap",
    "generatedValue": null,
    "mappedField": null
  },
  "adtaxi-tracking.profile": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_adtaxi_domain"
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "right-middle",
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "knock-chatbot.api_token": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_knock_company_token"
  },
  "scheduletourform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore affordable two- and three-bedroom apartment floor plans at Cedar Creek Crossing in Quincy, IL. As an LIHTC affordable housing community with project-based Section 8 apartment homes, Cedar Creek Crossing provides housing opportunities for qualifying households.</p><p>Income limits range from 20% to 60% of the Area Median Income (AMI), depending on the apartment home. Housing Choice Vouchers are accepted. Browse current floor plans and contact our leasing team to determine which income qualifications apply to an available home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Affordable 2 &amp; 3 Bedroom Apartments in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.description": {
    "overrideType": "VALUE",
    "customValue": "<p>We accept cats and dogs. One-time pet fee: $200 per pet. Monthly pet rent: $25 per pet. Maximum of 2 pets per apartment home. There is no weight limit. Breed restrictions apply.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.pet_deposit_label": {
    "overrideType": "VALUE",
    "customValue": "<p>Pet deposit</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.pet_deposit_value": {
    "overrideType": "VALUE",
    "customValue": "200",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Cedar Creek Crossing in Quincy, IL, where spacious, affordable two- and three-bedroom apartments meet everyday comfort and convenience. With thoughtfully designed floor plans, community amenities, and professional on-site management, Cedar Creek Crossing offers an inviting place to call home.</p><p>Cedar Creek Crossing participates in the Low-Income Housing Tax Credit (LIHTC) program and offers project-based Section 8 apartment homes. Depending on the apartment home, income limits range from 20% to 60% of the Area Median Income (AMI). Housing Choice Vouchers are also accepted.</p><p>Explore our affordable apartments in Quincy, IL, and contact our leasing team to learn more about current availability and income qualifications.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "petscallout.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019e85db-45c6-7570-8b98-f085354e1af6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Woman holding a dog indoors."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "communityamenitieslist.items": {
    "limit": null,
    "hiddenIds": [
      "custom_4bd94f90-9871-48a7-8ee8-64836dc944a7",
      "custom_fbacbefe-1b81-4726-b5dc-1b12806c736a",
      "custom_606955e1-98a1-425b-9c09-078084e67434",
      "custom_5ef39510-5511-4830-b35c-31a962adb7d8"
    ],
    "orderedIds": null,
    "hiddenIndices": [
      2,
      6,
      8,
      10,
      7,
      9
    ],
    "ordering": null,
    "customItems": null
  },
  "interioramenitieslist.items": {
    "limit": null,
    "hiddenIds": [
      "custom_43f659cc-7710-4485-8164-ea22af734514",
      "custom_b58a51ca-9a65-4234-9e04-4d2c2c6a85e6",
      "custom_31827a3c-1c74-4393-98c9-f3b13775e54c",
      "custom_84ed6f9b-94a0-458f-b85b-41d39f424a11",
      "custom_036b56c8-ec0d-4fcf-9d20-b6e6407eacbe",
      "custom_3156bbac-0b81-404e-9857-dad0cedaa80c"
    ],
    "orderedIds": null,
    "hiddenIndices": [
      1,
      3,
      6,
      9,
      13,
      15
    ],
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "adtaxi-tracking",
      "blockId": "adtaxi-tracking",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "knock-chatbot",
      "blockId": "knock-chatbot",
      "position": 0
    },
    {
      "sectionId": "realpage-calendar",
      "blockId": "realpage-calendar",
      "position": 0
    }
  ]
};

export const styleOverrides = {
  "_section.InstagramSection": {
    "properties": {
      "display": "none"
    }
  }
};
